export default "__VITE_ASSET__b798f679__"